var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { UserDevice } from "@@/Device";
import { action, makeObservable, observable } from "mobx";
// import { UserDevice } from '../../../../../letrcore/src/Device';
// import { DStore } from "../DeviceStore";
export class AdminDeviceViewStore {
    constructor() {
        this.userid = "";
        this.currentos = "";
        this.deviceModelName = "";
        this.brand = "";
        this.deviceManufacturer = "";
        this.currentDeviceid = "";
        this.userDevices = [];
        this.loadingdevices = false;
        makeObservable(this);
        APPEvent.addSubcriberForAdminUserDevicesRes((devices) => {
            this.setLoadingDevices(false);
            this.setDevices(devices);
        });
        APPEvent.addSubscriberForAdminEditDeviceRes((ret) => {
            var _a, _b;
            if (ret !== undefined && ret.type === "Remove") {
                let removed = false;
                if (ret.success !== undefined && ret.success) {
                    if (this.currentdevice !== undefined) {
                        this.removeFromArray(this.currentdevice);
                    }
                    this.setDeviceid(undefined);
                    removed = true;
                }
                (_a = this.onremovedevicecb) === null || _a === void 0 ? void 0 : _a.call(this, removed);
            }
            else if (ret !== undefined && ret.type === "Logout" && ret.success !== undefined && ret.success) {
                let loggedout = false;
                if (ret.success !== undefined && ret.success) {
                    loggedout = true;
                }
                (_b = this.onlogoutdevicecb) === null || _b === void 0 ? void 0 : _b.call(this, loggedout);
            }
        });
    }
    setUserid(userid) {
        this.userid = userid;
        this.reset();
        this.setDeviceid(undefined);
        this.loadDevices();
    }
    setLoadingDevices(load) {
        this.loadingdevices = load;
    }
    setDeviceid(ud) {
        var _a, _b;
        if (ud !== undefined) {
            this.brand = (_a = ud === null || ud === void 0 ? void 0 : ud.metadat) === null || _a === void 0 ? void 0 : _a.deviceBrand;
            this.currentos = ud.metadat.deviceOS;
            this.deviceModelName = ud.metadat.deviceModelName;
            this.deviceManufacturer = ud.metadat.deviceManufacturer;
        }
        this.currentdevice = ud;
        this.currentDeviceid = (_b = ud === null || ud === void 0 ? void 0 : ud.id) !== null && _b !== void 0 ? _b : "";
    }
    reset() {
        this.userDevices = [];
    }
    setDevices(ud) {
        this.userDevices = ud;
    }
    async removeDevice() {
        if (!this.currentDeviceid) {
            return false;
        }
        const req = {
            userid: this.userid,
            deviceid: this.currentDeviceid,
            type: 'Remove'
        };
        Apphandler.sendMessage("admineditdevice", req);
        // const ret = await DStore.removeDevice(this.userid, this.currentdevice.id);
        // if (ret) {
        //     this.removeFromArray(this.currentdevice);
        //     this.setDeviceid(undefined);
        // }
        // return ret;
    }
    async logoutDevice() {
        if (!this.currentdevice) {
            return false;
        }
        const req = {
            userid: this.userid,
            deviceid: this.currentDeviceid,
            type: 'Logout'
        };
        Apphandler.sendMessage("admineditdevice", req);
        // const ret = await DStore.logoutDevice(this.userid, this.currentdevice.id);
        // return ret;
    }
    removeFromArray(device) {
        const index = this.userDevices.indexOf(device);
        if (index !== -1) {
            this.userDevices.splice(index, 1);
        }
    }
    async loadDevices() {
        this.setLoadingDevices(true);
        // const mydevices = await DStore.getUserDevices(this.userid);
        // if (mydevices) {
        //     this.setDevices(mydevices);
        // }
        const req = {
            userid: this.userid
        };
        Apphandler.sendMessage("getuserdevices", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "userid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "currentos", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "deviceModelName", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "brand", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "deviceManufacturer", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "currentDeviceid", void 0);
__decorate([
    observable,
    __metadata("design:type", UserDevice)
], AdminDeviceViewStore.prototype, "currentdevice", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminDeviceViewStore.prototype, "userDevices", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminDeviceViewStore.prototype, "loadingdevices", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminDeviceViewStore.prototype, "setUserid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminDeviceViewStore.prototype, "setLoadingDevices", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UserDevice]),
    __metadata("design:returntype", void 0)
], AdminDeviceViewStore.prototype, "setDeviceid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminDeviceViewStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminDeviceViewStore.prototype, "setDevices", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [UserDevice]),
    __metadata("design:returntype", void 0)
], AdminDeviceViewStore.prototype, "removeFromArray", null);
